module.exports = __webpack_public_path__ + "img/core-values-4.8ce2f968.svg";